import { render } from "./date-picker-year.vue?vue&type=template&id=4a8790d2&scoped=true"
import script from "./date-picker-year.vue?vue&type=script&lang=js"
export * from "./date-picker-year.vue?vue&type=script&lang=js"

import "./date-picker-year.vue?vue&type=style&index=0&id=4a8790d2&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8790d2"]])

export default __exports__